export function setCookie(name: string, value: string, days: number, domain: string): void {
	let expires = "";
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `; expires=${date.toUTCString()}`;
	}

	const domainString = domain ? `; domain=${domain}` : "";
	document.cookie = `${name}=${value}${expires}${domainString}; path=/`;
}
